exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".question-answer-list[data-v-765aaaca]{display:flex;flex-flow:column wrap;column-gap:3rem;max-height:10rem;width:max-content;margin-bottom:1rem;margin-top:1rem}.question-answer[data-v-765aaaca]{font-size:1.15rem;color:#A09C9C;max-width:15rem;list-style-type:'-'}\n", ""]);

